// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._31A1H8LN8FhMDQl41NzgP {\n  text-align: center;\n  font-size: 1.3rem;\n  letter-spacing: 2px;\n  padding: 20px 0;\n}\n\n._3-GbQrbCIVH7paJUCGEjMY:link,\n._3-GbQrbCIVH7paJUCGEjMY:hover,\n._3-GbQrbCIVH7paJUCGEjMY:active,\n._3-GbQrbCIVH7paJUCGEjMY:visited {\n  color: var(--body-color);\n  border: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"footer": "_31A1H8LN8FhMDQl41NzgP",
	"a": "_3-GbQrbCIVH7paJUCGEjMY"
};
module.exports = exports;
